module.exports = __webpack_public_path__ + "static/img/alerthome.ee4507b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/activty/alerthome.svg
// module id = nz32
// module chunks = 1